import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import LabeledLinkStandard from '~/components/cms/custom/LabeledLink/LabeledLinkStandard.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LabeledLink',
  props: {
    title: null,
    image: null,
    inBlockIconLabeledLinks: {
      type: Boolean
    },
    mediaLink: null,
    text: null,
    externalLinkUrl: null
  },
  setup: function setup(__props) {
    var props = __props;
    var LabeledLinkInBlockIconLabeledLinks = function LabeledLinkInBlockIconLabeledLinks() {
      return import('~/components/cms/custom/LabeledLink/LabeledLinkInBlockIconLabeledLinks.vue');
    };
    var link = computed(function () {
      if (props.mediaLink && props.mediaLink.fields.file.url) {
        return props.mediaLink.fields.file.url;
      } else if (props.externalLinkUrl) {
        return props.externalLinkUrl;
      }
    });
    var componentName = computed(function () {
      return props.inBlockIconLabeledLinks ? LabeledLinkInBlockIconLabeledLinks : LabeledLinkStandard;
    });
    var _useParseDocumentToHt = useParseDocumentToHtml(props.text),
      parsedText = _useParseDocumentToHt.html;
    return {
      __sfc: true,
      LabeledLinkInBlockIconLabeledLinks: LabeledLinkInBlockIconLabeledLinks,
      props: props,
      link: link,
      componentName: componentName,
      parsedText: parsedText
    };
  }
});